module.exports = __webpack_public_path__ + "overview-d35a4493/mapIcon-bcfaa1f03e9f672f90174d3a81ba8f12.svg";